import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Inject, OnInit } from "@angular/core";
import { ModalPreset } from "@modules/+new/shared/universal-modal/entities/modal-preset.interface";
import { UniversalModalService } from "@modules/+new/shared/universal-modal/universal-modal.service";
import { SuccessData } from "./entities/success-data.interface";
import { SuccessTransforms } from "./entities/success-transforms.interface";
import { ModalCloseReason } from "@modules/+new/shared/universal-modal/entities/modal-close-reason.enum";
import { CASH_PLUS } from "@helpers/constants";
import { CashPlusRouteName } from "@modules/cashplus/entities/cashplus.navigation.model";
import { Router } from "@angular/router";
import { CashPlusTrackingFacade } from "@modules/cashplus/+state/cashplus-tracking.facade";

@Component({
	selector: "modal-success",
	templateUrl: "./success.component.html",
	styleUrls: ["./success.component.scss"],
	providers: [CashPlusTrackingFacade],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class SuccessComponent implements ModalPreset<SuccessData>, OnInit {
	private readonly transforms: SuccessTransforms;
	public data: SuccessData = {};

	private cashPlusTrackingFacade = inject(CashPlusTrackingFacade);

	public constructor(
		@Inject(UniversalModalService) private modal,
		private cdr: ChangeDetectorRef,
		private readonly router: Router
	) {}

	private setTransforms = async (): Promise<boolean> => {
		if (!this.transforms) {
			return false;
		}
		this.data = await this.transforms.transform(this.data || {});
		this.close = this.transforms.onDone || this.close;
	};

	public ngOnInit(): void {
		this.setTransforms().then(() => this.cdr.markForCheck());
	}

	// TODO: eslint fix
	/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
	public close = (): any => this.modal.close(ModalCloseReason.close);

	public discoverCashPlus(): void {
		this.cashPlusTrackingFacade.discoverCashPlusClicked("Deposit successful");
		this.router.navigate([{ outlets: { modal: [CASH_PLUS, CashPlusRouteName.Intro] } }]);
	}

	public exploreAssets(): void {
		this.modal.close(ModalCloseReason.close);
		this.router.navigateByUrl("/prices");
	}
}
